import { Modal } from '@foam/buoy/src/components/Modal/Modal';
import { useCallback, useMemo, useState } from 'react';
import { CreatorGender } from '~/clientApi/creator.model';
import { getMainPlatformData } from '~/core/utils';
import { ProfileInformation } from '~/screens/AddTalent/ProfileInformation';
import { ConfirmChanges } from '~/screens/MyAgency/components/ConfirmChanges';
import { useEditCreatorStore } from '~/screens/MyAgency/store/useEditCreatorStore';

import { convertVerticalsToArray } from './utils';

export const EditCreatorModal: React.FC = () => {
  const [isDirty, setDirty] = useState(false);
  const { selectedCreator, isEditModalOpen, closeEditModal } =
    useEditCreatorStore();

  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);

  const { name = '' } = useMemo(() => {
    if (selectedCreator) return getMainPlatformData(selectedCreator);

    return {};
  }, [selectedCreator]);

  const onCloseModal = useCallback(() => {
    if (isEditModalOpen && isDirty) {
      setIsConfirmationModalOpen(true);
      return;
    }
    closeEditModal();
  }, [closeEditModal, isEditModalOpen, setIsConfirmationModalOpen, isDirty]);

  const onSuccess = useCallback(() => {
    closeEditModal();
  }, [closeEditModal]);

  const keepEditing = useCallback(() => {
    setIsConfirmationModalOpen(false);
  }, [setIsConfirmationModalOpen]);

  const leavePage = useCallback(() => {
    setIsConfirmationModalOpen(false);
    closeEditModal();
  }, [closeEditModal, setIsConfirmationModalOpen]);

  return (
    <Modal.Instance open={isEditModalOpen} onOpenChange={onCloseModal}>
      <ProfileInformation
        onClose={closeEditModal}
        onUpdate={onSuccess}
        isEdit
        title={`${name}'s profile information`}
        creator={{
          id: selectedCreator?.id,
          avatar: selectedCreator?.avatar,
          firstName: selectedCreator?.firstName as string,
          lastName: selectedCreator?.lastName,
          bio: selectedCreator?.bioAgency,
          dateOfBirth: selectedCreator?.dateOfBirth || undefined,
          gender: selectedCreator?.genderAgency as CreatorGender,
          // @ts-ignore
          location: selectedCreator?.location,
          verticals: convertVerticalsToArray(selectedCreator?.categoryAgency),
          platforms: selectedCreator?.platforms,
          updatedAt: selectedCreator?.updatedAt,
        }}
        setDirty={setDirty}
      />
      <ConfirmChanges
        hasUnsavedChanges={isConfirmationModalOpen}
        keepEditing={keepEditing}
        leavePage={leavePage}
      />
    </Modal.Instance>
  );
};
